/* Visso — scripts du thème (sans dépendance) */
(function () {
  'use strict';

  /* En-tête : bordure au défilement */
  var header = document.querySelector('[data-header]');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 4); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* Galerie + mètre-ruban */
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var track = gallery.querySelector('[data-gallery-track]');
    var slides = track ? Array.prototype.slice.call(track.children) : [];
    var fill = gallery.querySelector('[data-tape-fill]');
    var label = gallery.querySelector('[data-tape-label]');
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-thumb]'));
    if (!track || !slides.length) return;
    var n = slides.length;

    var current = function () {
      var center = track.scrollLeft + track.clientWidth / 2;
      var best = 0, bestDist = Infinity;
      slides.forEach(function (s, i) {
        var c = s.offsetLeft + s.offsetWidth / 2;
        var d = Math.abs(c - center);
        if (d < bestDist) { bestDist = d; best = i; }
      });
      return best;
    };
    var update = function () {
      var i = current();
      if (fill) {
        fill.style.left = (i / n * 100) + '%';
        fill.style.width = (100 / n) + '%';
      }
      if (label) label.textContent = (i + 1) + ' / ' + n;
      thumbs.forEach(function (t, k) { t.setAttribute('aria-current', k === i ? 'true' : 'false'); });
    };
    var raf;
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(update);
    }, { passive: true });
    thumbs.forEach(function (t, k) {
      t.addEventListener('click', function () {
        track.scrollTo({ left: slides[k].offsetLeft - track.offsetLeft, behavior: 'smooth' });
      });
    });
    window.addEventListener('resize', update);
    update();
  });

  /* Quantité */
  document.querySelectorAll('[data-qty]').forEach(function (box) {
    var input = box.querySelector('input');
    box.querySelectorAll('button[data-step]').forEach(function (b) {
      b.addEventListener('click', function () {
        var v = parseInt(input.value, 10) || 1;
        v = Math.max(parseInt(input.min || '1', 10), v + parseInt(b.dataset.step, 10));
        input.value = v;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  /* Variantes : met à jour le prix et le bouton */
  document.querySelectorAll('[data-variant-select]').forEach(function (select) {
    var root = select.closest('[data-buy]');
    if (!root) return;
    select.addEventListener('change', function () {
      var opt = select.options[select.selectedIndex];
      root.querySelectorAll('[data-price]').forEach(function (el) { el.textContent = opt.dataset.price; });
      var available = opt.dataset.available === 'true';
      root.querySelectorAll('[data-buy-button]').forEach(function (b) {
        b.disabled = !available;
        var t = b.querySelector('[data-buy-label]');
        if (t) t.textContent = available ? b.dataset.labelOn : b.dataset.labelOff;
      });
      var url = new URL(window.location.href);
      url.searchParams.set('variant', select.value);
      window.history.replaceState({}, '', url.toString());
    });
  });

  /* Barre d'achat collante : visible quand le bouton principal sort de l'écran */
  var mainBtn = document.querySelector('[data-main-buy]');
  var sticky = document.querySelector('[data-sticky-buy]');
  if (mainBtn && sticky && 'IntersectionObserver' in window) {
    var footer = document.querySelector('.site-footer');
    var mainVisible = true, footerVisible = false;
    var sync = function () { sticky.classList.toggle('is-visible', !mainVisible && !footerVisible); };
    new IntersectionObserver(function (e) {
      mainVisible = e[0].isIntersecting;
      sync();
    }).observe(mainBtn);
    if (footer) new IntersectionObserver(function (e) { footerVisible = e[0].isIntersecting; sync(); }).observe(footer);
  }

  /* Date de livraison : jours ouvrés, week-ends et jours fériés français exclus */
  var pad = function (x) { return (x < 10 ? '0' : '') + x; };
  var key = function (d) { return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()); };
  var easter = function (y) {
    var a = y % 19, b = Math.floor(y / 100), c = y % 100, d = Math.floor(b / 4), e = b % 4,
      f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30,
      i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451),
      month = Math.floor((h + l - 7 * m + 114) / 31), day = ((h + l - 7 * m + 114) % 31) + 1;
    return new Date(y, month - 1, day);
  };
  var holidays = {};
  var addHolidays = function (y) {
    ['01-01', '05-01', '05-08', '07-14', '08-15', '11-01', '11-11', '12-25'].forEach(function (md) { holidays[y + '-' + md] = 1; });
    var e = easter(y);
    [1, 39, 50].forEach(function (off) { var d = new Date(e); d.setDate(d.getDate() + off); holidays[key(d)] = 1; });
  };
  var now = new Date();
  addHolidays(now.getFullYear()); addHolidays(now.getFullYear() + 1);
  var isWorkday = function (d) { var w = d.getDay(); return w !== 0 && w !== 6 && !holidays[key(d)]; };
  var addWorkdays = function (start, n) {
    var d = new Date(start.getFullYear(), start.getMonth(), start.getDate());
    var added = 0;
    while (added < n) { d.setDate(d.getDate() + 1); if (isWorkday(d)) added++; }
    return d;
  };
  var fmt = new Intl.DateTimeFormat('fr-FR', { weekday: 'long', day: 'numeric', month: 'long' });
  document.querySelectorAll('[data-delivery]').forEach(function (el) {
    var min = parseInt(el.dataset.min, 10) || 2;
    var max = parseInt(el.dataset.max, 10) || 5;
    var cutoff = parseInt(el.dataset.cutoff, 10);
    var start = new Date(now);
    if (!isWorkday(start) || (!isNaN(cutoff) && start.getHours() >= cutoff)) {
      // commande traitée le jour ouvré suivant
      start = addWorkdays(start, 1);
    }
    var dMin = addWorkdays(start, min), dMax = addWorkdays(start, max);
    var out = el.dataset.mode === 'range'
      ? 'entre le ' + fmt.format(dMin) + ' et le ' + fmt.format(dMax)
      : fmt.format(dMax);
    el.textContent = out;
  });
})();
